import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  BehaviorSubject,
  Observable,
  catchError,
  map,
  retry,
  throwError,
} from 'rxjs'
import {
  Assistant,
  BdState,
  IaState,
  Note,
  OutsideActivity,
  PersonalAccount,
  Rep,
  RepCode,
  RepFirm,
  RepLicense,
  RepPro,
  RepSocialMedia,
  RepSubscription,
  Solicitor,
} from '../../models/repEditorModels'

@Injectable({
  providedIn: 'root',
})
export class ClientServices extends BehaviorSubject<any[]> {
  private data: any[] = []
  constructor(private _http: HttpClient) {
    super([])
  }
  GetCurrentSuperUserRepid(): Observable<object> {
    return this._http
      .get<any>(`/api/Rep/GetRepbySuperUser`)
      .pipe(catchError(this.handleError))
  }

  // take: optional row cap so a grid can paint a first page before the full
  // list arrives. Omit for every record.
  getaccountlistbyRepId(take?: number): Observable<object[]> {
    const query = take ? `?take=${take}` : ''
    return this._http
      .get<any[]>(`/api/Clients/RetrieveAllclientsbyRepId${query}`)
      .pipe(catchError(this.handleError))
  }
  getaccountlistbyRepIdselected(repId: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetClientList`, repId)
      .pipe(catchError(this.handleError))
  }
  getAdvisorClientList(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Clients/getAdvisorClientLists`)
      .pipe(catchError(this.handleError))
  }
  getClientList(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetListofReps`)
      .pipe(catchError(this.handleError))
  }
  getRepListAll(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetListofAllReps`)
      .pipe(catchError(this.handleError))
  }
  getRepCodescodeList(p: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetRepCodescodeList`, p)
      .pipe(catchError(this.handleError))
  }
  getRepCodeList(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetRepCodesList`, r)
      .pipe(catchError(this.handleError))
  }
  getRepCodeListAll(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetRepCodesListall`)
      .pipe(catchError(this.handleError))
  }
  GetRepCodesListall(r: any): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetRepCodesListall`)
      .pipe(catchError(this.handleError))
  }

  //GetRepCodesList
  getRepCodesForRep(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetRepCodesForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getRepViewList(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetRepListForViewRepor`)
      .pipe(catchError(this.handleError))
  }
  getSuperAdminList(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetSuperAdminReplist`)
      .pipe(catchError(this.handleError))
  }
  getAssistantList(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetAssistantlist`)
      .pipe(catchError(this.handleError))
  }
  ResetSuperAdminRepId(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/ResetSuperAdminRepId`)
      .pipe(catchError(this.handleError))
  }
  getRepById(r: any): Observable<any> {
    return this._http
      .post<any>(`/api/Rep/GetRepById`, r)
      .pipe(catchError(this.handleError))
  }
  getRepByIdAsync(r: any): Promise<any> {
    return this._http
      .post<any>(`/api/Rep/GetRepById`, r)
      .pipe(catchError(this.handleError))
      .toPromise()
  }
  getBdStatesForRep(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetBdStatesForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getIaStatesForRep(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetIaStatesForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getAssistantForRep(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetAssistantForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getRepLicenseForRep(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetRepLicenseForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getNotesForRep(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetNotesForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getPersonalAccountsForRep(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetOutsideAccountsForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getOutsideActivityForRep(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetOutsideActivityForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getRepProForRep(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetRepProForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getRepFirmForRep(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetRepFirmForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getRepSocialMediaForRep(r: any): Observable<RepSocialMedia[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetRepSocialMediaForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getSolicitorForRep(r: any): Observable<Solicitor[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetSolicitorForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getRepSubscriptionForRep(r: any): Observable<RepSubscription[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetRepSubscriptionForRep`, r)
      .pipe(catchError(this.handleError))
  }
  getRepLookups(): Observable<any> {
    return this._http
      .get<any>(`/api/Rep/GetRepLookups`)
      .pipe(catchError(this.handleError))
  }
  getClientRepIdList(c: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetClientList`, c)
      .pipe(catchError(this.handleError))
  }
  getClientClientList(r: any): Observable<any> {
    return this._http
      .post<any>(`/api/Rep/getClientListread`, r)
      .pipe(catchError(this.handleError))
  }
  getClientListbyBranch(b: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetListofReps`, b)
      .pipe(catchError(this.handleError))
  }
  getproductypelist(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetProducttypeList`, r)
      .pipe(catchError(this.handleError))
  }
  getTransactionTypelist(): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetTransactionTypeList`)
      .pipe(catchError(this.handleError))
  }
  getsourceoffundtypelist(cliId: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetSourceofFundtypeList`, cliId)
      .pipe(catchError(this.handleError))
  }
  getblotterlist(b: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Blotter/getblotterList`, b)
      .pipe(catchError(this.handleError))
  }

/*     getAccountformReviewslist(b: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Blotter/getAccountformReview`, b)
      .pipe(catchError(this.handleError))
  } <AP> Needed to replace this table. </AP>*/
  getAccountformReviewslist(b: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Blotter/GetBlotterStatus`, b)
      .pipe(catchError(this.handleError))
  }

  // getAccountformReview
  getblotterCommentlist(b: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Blotter/getblotterComment`, b)
      .pipe(catchError(this.handleError))
  }
  getAlertLoglist(b: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Blotter/getAlertinfo`, b)
      .pipe(catchError(this.handleError))
  }
  getClientProfileRecords(c: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Clients/getclientProfilerecords`, c)
      .pipe(catchError(this.handleError))
  }
  getReportData(input: any): Observable<Blob> {
    return this._http
      .post(`/api/Rep/GetReportById`, input, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  getRepReports(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetRepReports`)
      .pipe(catchError(this.handleError))
  }
  getReportPdf(input: any): Observable<Blob> {
    return this._http
      .post(`/api/Rep/GetRepPdfReport`, input, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  SubmitblotterInfo(b: any): Observable<object> {
    return this._http
      .post(`/api/Blotter/submitblotterinfo`, b)
      .pipe(catchError(this.handleError))
  }
  submitRepUpdate(rep: Rep): Observable<any> {
    return this._http
      .post<Rep>(`/api/Rep/SubmitRepUpdate`, rep)
      .pipe(catchError(this.handleError))
  }
  getRepRole(email: any): Observable<any> {
    return this._http
      .post<any>(`/api/Rep/GetReprolelist`, email)
      .pipe(catchError(this.handleError))
  }
  submitAssistantUpdate(assistant: Assistant): Observable<any> {
    return this._http
      .post<Assistant>(`/api/Rep/SubmitAssistantUpdate`, assistant)
      .pipe(catchError(this.handleError))
  }
  submitBdStateUpdate(bdState: BdState): Observable<any> {
    return this._http
      .post<BdState>(`/api/Rep/SubmitBdStateUpdate`, bdState)
      .pipe(catchError(this.handleError))
  }
  removeBdStateUpdate(bdState: BdState): Observable<any> {
    return this._http
      .post<BdState>(`/api/Rep/DeactivateBdState`, bdState)
      .pipe(catchError(this.handleError))
  }
  submitIaStateUpdate(iaState: IaState): Observable<any> {
    return this._http
      .post<IaState>(`/api/Rep/SubmitIaStateUpdate`, iaState)
      .pipe(catchError(this.handleError))
  }
  removeIaStateUpdate(iaState: IaState): Observable<any> {
    return this._http
      .post<IaState>(`/api/Rep/RemoveIaStateUpdate`, iaState)
      .pipe(catchError(this.handleError))
  }
  submitRepLicenseUpdate(repLicense: RepLicense): Observable<any> {
    return this._http
      .post<RepLicense>(`/api/Rep/SubmitRepLicenseUpdate`, repLicense)
      .pipe(catchError(this.handleError))
  }
  submitNoteUpdate(note: Note): Observable<any> {
    return this._http
      .post<Note>(`/api/Rep/SubmitNoteUpdate`, note)
      .pipe(catchError(this.handleError))
  }
  submitPersonalAccountUpdate(outsideAccount: PersonalAccount) {
    return this._http
      .post<PersonalAccount>(
        `/api/Rep/SubmitOutsideAccountUpdate`,
        outsideAccount,
      )
      .pipe(catchError(this.handleError))
  }
  submitOutsideActivityUpdate(outsideActivity: OutsideActivity) {
    return this._http
      .post<OutsideActivity>(
        `/api/Rep/SubmitOutsideActivityUpdate`,
        outsideActivity,
      )
      .pipe(catchError(this.handleError))
  }
  submitRepProUpdate(repPro: RepPro) {
    return this._http
      .post<RepPro>(`/api/Rep/SubmitRepProUpdate`, repPro)
      .pipe(catchError(this.handleError))
  }
  submitRepFirmUpdate(repFirm: RepFirm) {
    return this._http
      .post<RepFirm>(`/api/Rep/SubmitRepFirmUpdate`, repFirm)
      .pipe(catchError(this.handleError))
  }
  submitRepCodeUpdate(repCode: RepCode) {
    return this._http
      .post<RepCode>(`/api/Rep/SubmitRepCodeUpdate`, repCode)
      .pipe(catchError(this.handleError))
  }
  submitRepSocialMediaUpdate(repSocialMedia: RepSocialMedia) {
    return this._http
      .post<RepSocialMedia>(
        `/api/Rep/SubmitRepSocialMediaUpdate`,
        repSocialMedia,
      )
      .pipe(catchError(this.handleError))
  }
  submitSolicitorUpdate(solicitor: Solicitor) {
    return this._http
      .post<Solicitor>(`/api/Rep/SubmitSolicitorUpdate`, solicitor)
      .pipe(catchError(this.handleError))
  }
  submitRepSubscriptionUpdate(repSubscription: RepSubscription) {
    return this._http
      .post<RepSubscription>(
        `/api/Rep/SubmitRepSubscriptionUpdate`,
        repSubscription,
      )
      .pipe(catchError(this.handleError))
  }
  RetrieveBlotterInfo(blott: any): Observable<object[]> {
    return this._http
      .post<any[]>('/api/Blotter/EditBlotterInfo', blott)
      .pipe(catchError(this.handleError))
  }

/*   RetrieveRepBranchList(): Observable<string[]> {
    return this._http
      .get<string[]>(`/api/Transactions/RetrieveRepbranchlist`)
      .pipe(catchError(this.handleError))
  } */

            getproductList(): Observable<any> {
    return this._http
      .get<any>('/api/auth/GetProductTypes')
      .pipe(catchError(this.handleError))
  }
      RetrieveRepBranchList(): Observable<any> {
    return this._http
      .get<any>('/api/Transactions/RetrieveRepbranchlist')
      .pipe(catchError(this.handleError))
  }
  RetrieveRepBranchLink(email: any): Observable<any[]> {
    return this._http
      .post<string[]>(`/api/Transactions/RetrieveRepBranchLinks`, email)
      .pipe(catchError(this.handleError))
  }
  GetAddonAdditionalAccountlist(param: any): Observable<any[]> {
    return this._http
      .post<string[]>(`/api/Transactions/getAccountFormList`, param)
      .pipe(catchError(this.handleError))
  }
  GetAddonAdditionalAccountlistNoBlotterId(param: any): Observable<any[]> {
    return this._http
      .post<string[]>(`/api/Transactions/getAccountFormListnoblotter`, param)
      .pipe(catchError(this.handleError))
  }
  read() {
    return this._http.get(`/api/Clients/RetrieveAllclients`)
  }
  private fetch(action: string = '', data?: any): Observable<any[]> {
    return this._http
      .get(`/api/Clients/RetrieveAllclients`)
      .pipe(map((res) => <any[]>res))
      .pipe(catchError(this.handleError))
  }
  private reset() {
    this.data = []
  }
  // Edit View Account info //
  getAccountInfofromviewAccount(c: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/getClientListread`, c)
      .pipe(retry(0), catchError(this.handleError))
  }
  getClientAccountNotes(c: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Clients/getclientnotes`, c)
      .pipe(retry(0), catchError(this.handleError))
  }
    getBlotterAccountNotes(c: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Blotter/getblotterComment`, c)
     
    }
  handleError(error) {
    let errorMessage = ''
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`
    }
 //   console.log(errorMessage)
    return throwError(errorMessage)
  }

  /*  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || ''; const err = body || JSON.stringify(body); errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else { errMsg = error.message ? error.message : error.toString(); }
    return Promise.reject(errMsg);
  } */
}
